import React, { Suspense } from "react";
import { LoadingSpinner } from "components/v2/Loading/LoadingSpinner/LoadingSpinner";

export default (Component) => (props) =>
  (
    <Suspense fallback={<LoadingSpinner className="suspenseFallback" />}>
      <Component {...props} />
    </Suspense>
  );
